// DashboardClusterTopology.jsx
// This file defines a lightweight placeholder page for the "Cluster Topology"
// section of the admin dashboard. It currently renders a small content
// container with a short description. Keep imports minimal to avoid
// unused dependency warnings if this page is extended later.

import { Typography } from "@mui/material";

import MainPanelContent from "../components/MainPanelContent";
import ClusterTopologyPage from "./ClusterTopology/ClusterTopologyPage";

// Functional React component that renders the Cluster Topology panel.
// - It uses `MainPanelContent` for consistent layout within the admin
//   dashboard area.
// - The body currently contains a placeholder text (TBD) which should be
//   replaced by the actual topology visualization or summary when ready.
const DashboardClusterTopology = () => {
  return (
    <MainPanelContent maxWidth={null}>
      {/* Short explanatory text shown under the panel title. Replace when
          the topology component or details are implemented. */}
      {/* <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        TBD
      </Typography> */}
      <ClusterTopologyPage />
    </MainPanelContent>
  );
};

export default DashboardClusterTopology;
